module.exports = __webpack_public_path__ + "img/intro-pc-use.78c3b7f0.jpg";